






















































import Vue from 'vue'
import { mapGetters } from 'vuex'

import ManufacturerOverrideDialog from '../../components/admin/ManufacturerOverrideDialog.vue'

/* eslint-disable */ 
import { Product } from '../../models/Product'
/* eslint-enable */ 


export default Vue.extend({
  data: () => ({
    editProductDialog: false as boolean,
    createProductDialog: false as boolean,
    manufacturerOverrideDialog: false as boolean,
    search: '' as string,
    selectedProduct: null as any,
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      { text: 'Product Number', value: 'number' },
      { text: 'Retail Price', value: 'price' },
      { text: 'Retail FRT', value: 'frt' },
      { text: 'Dealer Price', value: 'dealerPrice', sortable: false },
      { text: 'Dealer FRT', value: 'dealerFrt', sortable: false }
    ],
    options: {
    },
    products: [] as Product[],
    totalProducts: 0,
    loading: false,
  }),
  components: {
    ManufacturerOverrideDialog
  },
  computed: {
    ...mapGetters({
      make: 'makes/currentMake',
      dealerId: 'dealers/currentDealerId',
    }),
    isMobile() : boolean {
      const { xs, sm } = this.$vuetify.breakpoint
      return xs || sm
    },
  },
  methods: {
    convertNullToDash(item: number) : string | number {
      return !item ? '-' : item
    },
    handleClick(product: Product) : void {
      this.selectedProduct = product
      this.manufacturerOverrideDialog = true
    },
    closeManufacturerDialog(resetProducts: boolean) : void {
      this.manufacturerOverrideDialog = false
      this.selectedProduct = null
      if (resetProducts) this.getDealerProducts()
    },
    async getDealerProducts() {
      this.loading = true
      const res = await Product.getDealerProducts('Manufacturer', this.make.id, this.dealerId, this.options, this.search)
      this.products = res.products
      this.totalProducts = res.total
      this.loading = false
    },
    createNewProduct() {
      this.createProductDialog = true
    }
  },
})
